
function setCount(count) {
  const cartElement = document.getElementById('cart-counter');
  const cartElementMob = document.getElementById('cart-counter-mob');
  if(cartElement != null){
    cartElement.classList.remove('hidden', 'flex');
    cartElement.innerHTML = count;
  }
  cartElementMob.classList.remove('hidden', 'flex');
  cartElementMob.innerHTML = count;
  //Code: dynamic aria-label for cart link
  const cartLink=document.getElementById('cartToggle');
  if(cartLink != null){
  cartLink.removeAttribute('aria-label')
  }
  const cartLinkMob=document.getElementById('cartToggleMob');
  cartLinkMob.removeAttribute('aria-label')
  if (count == 0) {
    if(cartElement != null){
    cartElement.classList.add('hidden');
    }
    cartElementMob.classList.add('hidden');
  } else {
    if(cartElement != null){
    cartElement.classList.add('flex');
    cartLink.setAttribute('aria-label','Cart ' + count + ' Having items')
    }
    cartElementMob.classList.add('flex');
    cartElementMob.setAttribute('aria-label','Cart ' + count + ' Having items')
  }
}

async function onCartChange() {
  const cart = await bloom.shoppingCart().get();
  setCount(cart.item_count)
}

async function initialize() {
  await bloom.shoppingCart().onChange(onCartChange)
}

ready(initialize);
